import React from 'react'
import {motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { containerVariants, itemVariants } from "../../variants/variants";

const Section4 = () => {
  const { t } = useTranslation();

  return (
    <motion.div
                initial="hidden"
                whileInView="visible"
                exit="exit"
                variants={containerVariants}
    
    className="grid grid-cols-10 pb-28 ">
    <div className='col-start-3 col-span-6   flex flex-col justify-center'>
        <motion.img variants={itemVariants} src='/images/social-responsibility/prize.svg' className="  h-20" />

        <motion.p variants={itemVariants} className='text-center mt-10 font-light text-20 text-customGray'>{t("socialResponsibility.amfori.text1")}</motion.p>


        <motion.p variants={itemVariants} className='text-center mt-10 font-light text-20 text-customGray'>{t("socialResponsibility.amfori.text2")}
        </motion.p>
    </div>
</motion.div>
  )
}

export default Section4
